import * as React from 'react'
import { ImgS } from "ui-seeker/core"

import { capitalize } from 'app/utils'
import { IMAGE } from 'app/@common/constants'


export default function RadioMultiButton({ item, id, onChange, value, sites, disabled }) {

    const isDisabled = (sites.length && !sites.map(a => a.value).includes(item.value)) || disabled

    const imgProps = {
        src: `${IMAGE.ASSETS}/${item.label?.toLowerCase().split('.')[0]}-mini.png`,
        alt: `${item.label} logo`,
        onError: i => i.target.src = `${IMAGE.ASSETS}/web.png`,
        style: { width: '15px', height: '15px', margin: '-2px 5px 0 0', opacity: isDisabled ? 0.5 : 1 }
    }

    return <>
        <input
            disabled={isDisabled}
            type="radio"
            id={`switch-${id}`}
            name="switch-toggle"
            value={item.value}
            onChange={() => !isDisabled && onChange(item.value)}
            checked={(Array.isArray(value) ? value.join().toString() : value?.toString()) === item.value.toString()}
        />
        <label className={isDisabled ? 'multi-button-disabled' : ''} htmlFor={`switch-${id}`}><ImgS {...imgProps} /> {capitalize(item.label)}</label>
    </>
}